export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">

      {/* ── 모바일 전용 compact 푸터 ── */}
      <div className="md:hidden px-4 py-5">
        {/* 상호 + 전화 */}
        <div className="flex items-center justify-between mb-3">
          <span className="text-sm font-bold text-teal-400">우리집익스프레스</span>
          <a href="tel:05071366-2424" className="flex items-center gap-1 text-xs text-gray-300 cursor-pointer">
            <i className="ri-phone-line text-teal-400"></i>
            0507-1366-2424
          </a>
        </div>

        {/* 빠른 링크 가로 나열 */}
        <div className="flex flex-wrap gap-x-3 gap-y-1 text-xs text-gray-400 mb-3">
          <a href="#introduction" className="hover:text-teal-400 transition-colors cursor-pointer">소개</a>
          <a href="#services" className="hover:text-teal-400 transition-colors cursor-pointer">서비스</a>
          <a href="#quote" className="hover:text-teal-400 transition-colors cursor-pointer">견적</a>
          <a href="#reviews" className="hover:text-teal-400 transition-colors cursor-pointer">후기</a>
          <a href="#gallery" className="hover:text-teal-400 transition-colors cursor-pointer">사진</a>
          <a
            href="http://blog.naver.com/basketer2400/224221230610"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="text-green-400 hover:text-green-300 transition-colors cursor-pointer"
          >
            블로그
          </a>
        </div>

        {/* 사업자 정보 한줄 */}
        <p className="text-[10px] text-gray-500 leading-5">
          철원글로벌물류 · 대표 유영조 · 사업자 127-42-17238<br />
          경기도 포천시 영북면 호국로 4184
        </p>

        {/* 카피라이트 */}
        <div className="flex items-center justify-between mt-3 pt-3 border-t border-gray-800">
          <p className="text-[10px] text-gray-500">© 2024 우리집익스프레스.</p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[10px] text-gray-500 hover:text-teal-400 transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>

      {/* ── 데스크탑 기존 레이아웃 ── */}
      <div className="hidden md:block py-12">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-3 gap-8 mb-8">
            <div>
              <h3 className="text-xl font-bold mb-3 text-teal-400">우리집익스프레스</h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                믿음직한 이사 서비스를 제공하는<br />
                우리집익스프레스입니다.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-3 text-base">빠른 링크</h4>
              <ul className="space-y-1.5 text-sm">
                <li><a href="#introduction" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">업체 소개</a></li>
                <li><a href="#services" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">서비스 안내</a></li>
                <li><a href="#quote" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">간편 견적</a></li>
                <li><a href="#reviews" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">이용 후기</a></li>
                <li><a href="#gallery" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">현장 사진</a></li>
                <li>
                  <a
                    href="http://blog.naver.com/basketer2400/224221230610"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="flex items-center gap-1.5 text-green-400 hover:text-green-300 transition-colors cursor-pointer"
                  >
                    <i className="ri-article-line"></i>
                    네이버 블로그
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold mb-3 text-base">연락처</h4>
              <ul className="space-y-1.5 text-sm text-gray-400">
                <li className="flex items-center gap-2">
                  <i className="ri-phone-line"></i>
                  <span>0507-1366-2424</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-line mt-0.5"></i>
                  <span>경기도 포천시 영북면 호국로 4184</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-6">
            <div className="mb-4 text-xs text-gray-500 leading-6 flex flex-wrap gap-x-3 gap-y-0.5">
              <span><strong className="text-gray-400">상호</strong> : 철원글로벌물류</span>
              <span className="text-gray-700">|</span>
              <span><strong className="text-gray-400">대표자</strong> : 유영조</span>
              <span className="text-gray-700">|</span>
              <span><strong className="text-gray-400">사업자등록번호</strong> : 127-42-17238</span>
              <span className="text-gray-700">|</span>
              <span><strong className="text-gray-400">개업연월일</strong> : 2014년 05월 20일</span>
              <span className="w-full"></span>
              <span><strong className="text-gray-400">사업장소재지</strong> : 경기도 포천시 영북면 호국로 4184</span>
            </div>
            <div className="flex justify-between items-center gap-3">
              <p className="text-sm text-gray-400">© 2024 우리집익스프레스. All rights reserved.</p>
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>

    </footer>
  );
}
